import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
  NumberInput,
  NumberField,
  ReferenceField,
  ReferenceInput,
  SelectInput,
} from 'react-admin';

const platformFilters = [
  <TextInput key="q" source="q" label="Search" alwaysOn />,
  <TextInput key="chain_uid" source="chain_uid" label="Chain UID" />,
  <TextInput key="type" source="type" />,
  <TextInput key="symbol" source="symbol" />,
  <TextInput key="address" source="address" />,
];

export const PlatformList = () => (
  <List filters={platformFilters} perPage={25}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <ReferenceField source="coin_id" reference="coins" label="Coin">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="chain_uid" label="Chain UID" />
      <TextField source="type" />
      <TextField source="symbol" />
      <TextField source="address" />
      <NumberField source="decimals" />
    </Datagrid>
  </List>
);

export const PlatformEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <ReferenceInput source="coin_id" reference="coins">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput source="chain_uid" label="Chain UID" />
      <TextInput source="type" />
      <TextInput source="symbol" />
      <TextInput source="address" />
      <NumberInput source="decimals" />
    </SimpleForm>
  </Edit>
);

export const PlatformCreate = () => (
  <Create>
    <SimpleForm>
      <ReferenceInput source="coin_id" reference="coins">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput source="chain_uid" label="Chain UID" required />
      <TextInput source="type" required />
      <TextInput source="symbol" />
      <TextInput source="address" />
      <NumberInput source="decimals" />
    </SimpleForm>
  </Create>
);

export const PlatformShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <ReferenceField source="coin_id" reference="coins" label="Coin">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="chain_uid" label="Chain UID" />
      <TextField source="type" />
      <TextField source="symbol" />
      <TextField source="address" />
      <NumberField source="decimals" />
    </SimpleShowLayout>
  </Show>
);
